import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { speak } from '../utils/speak';

const API = '/api';

function Cards() {
  const [cards, setCards] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [editCard, setEditCard] = useState(null);
  const [editNotes, setEditNotes] = useState('');
  const [editCategory, setEditCategory] = useState('');
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchCards();
    axios.get(`${API}/categories`).then(res => setCategories(res.data.flat));
  }, []);

  const fetchCards = async () => {
    try {
      const res = await axios.get(`${API}/cards`);
      setCards(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Karte löschen?')) return;
    try {
      await axios.delete(`${API}/cards/${id}`);
      setCards(cards.filter(c => c.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (card) => {
    setEditCard(card);
    setEditNotes(card.notes || '');
    setEditCategory(card.category_id || '');
  };

  const handleSaveEdit = async () => {
    try {
      const res = await axios.put(`${API}/cards/${editCard.id}`, {
        notes: editNotes,
        categoryId: editCategory || null,
      });
      setCards(cards.map(c => c.id === editCard.id ? { ...c, ...res.data } : c));
      setEditCard(null);
      setMessage({ type: 'success', text: 'Karte gespeichert!' });
      setTimeout(() => setMessage(null), 3000);
    } catch (err) {
      console.error(err);
    }
  };

  const filtered = cards.filter(c =>
    c.word.toLowerCase().includes(filter.toLowerCase()) ||
    c.translation.toLowerCase().includes(filter.toLowerCase())
  );

  const levelNames = { 1: 'Neu', 2: 'Anfänger', 3: 'Fortgeschritten', 4: 'Gut', 5: 'Gelernt' };

  return (
    <div>
      <h1>Meine Karten ({cards.length})</h1>

      <div className="card">
        <input
          type="text"
          placeholder="Karten durchsuchen..."
          value={filter}
          onChange={e => setFilter(e.target.value)}
          style={{ marginBottom: 0 }}
        />
      </div>

      {message && <div className={`message message-${message.type}`}>{message.text}</div>}
      {loading && <p>Lade Karten...</p>}

      {!loading && filtered.length === 0 && (
        <div className="card" style={{ textAlign: 'center', color: '#718096' }}>
          <p>Noch keine Karten vorhanden.</p>
          <p>Übersetze ein Wort und speichere es als Karte!</p>
        </div>
      )}

      {/* Edit Modal */}
      {editCard && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '1rem'
        }}>
          <div className="card" style={{ width: '100%', maxWidth: '500px', margin: 0 }}>
            <h2>Karte bearbeiten</h2>

            <div style={{ marginBottom: '1rem' }}>
              <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>{editCard.word}</div>
              <div style={{ color: '#4c51bf', fontSize: '1.1rem' }}>{editCard.translation}</div>
              <div style={{ fontSize: '0.85rem', color: '#718096', marginTop: '0.25rem' }}>
                {editCard.source_lang} → {editCard.target_lang}
              </div>
            </div>

            {editCard.example_source && (
              <div style={{
                background: '#f7fafc', borderRadius: '8px',
                padding: '0.75rem', marginBottom: '1rem',
                borderLeft: '4px solid #4c51bf'
              }}>
                <div style={{ fontSize: '0.8rem', color: '#718096', marginBottom: '0.25rem', fontWeight: '600' }}>
                  Beispielsatz
                </div>
                <div style={{ fontSize: '0.9rem' }}>{editCard.example_source}</div>
                <div style={{ fontSize: '0.9rem', color: '#4c51bf' }}>{editCard.example_target}</div>
              </div>
            )}

            <label style={{ fontSize: '0.85rem', color: '#718096', display: 'block', marginBottom: '0.25rem' }}>
              Kategorie
            </label>
            <select
              value={editCategory}
              onChange={e => setEditCategory(e.target.value)}
            >
              <option value="">Keine Kategorie</option>
              {categories.map(cat => (
                <option key={cat.id} value={cat.id}>{cat.name}</option>
              ))}
            </select>

            <label style={{ fontSize: '0.85rem', color: '#718096', display: 'block', marginBottom: '0.25rem' }}>
              Notizen
            </label>
            <textarea
              placeholder="Eselsbrücke, Kontext, eigene Notizen..."
              value={editNotes}
              onChange={e => setEditNotes(e.target.value)}
              style={{
                width: '100%', padding: '0.75rem', border: '2px solid #e2e8f0',
                borderRadius: '8px', fontSize: '0.95rem', resize: 'vertical',
                minHeight: '80px', fontFamily: 'inherit', marginBottom: '1rem'
              }}
            />

            <div style={{ display: 'flex', gap: '1rem' }}>
              <button className="btn-primary" onClick={handleSaveEdit}>
                Speichern
              </button>
              <button className="btn-secondary" onClick={() => setEditCard(null)}>
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}

      {filtered.map(card => (
        <div key={card.id} className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div style={{ fontWeight: '600', fontSize: '1.1rem' }}>{card.word}</div>
                <button onClick={() => speak(card.word, card.source_lang)}
                  style={{ background: 'none', border: 'none', fontSize: '1rem', cursor: 'pointer' }}>
                  Anhören
                </button>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div style={{ color: '#4c51bf', fontSize: '1rem' }}>{card.translation}</div>
                <button onClick={() => speak(card.translation, card.target_lang)}
                  style={{ background: 'none', border: 'none', fontSize: '1rem', cursor: 'pointer' }}>
                  Anhören
                </button>
              </div>
              <div style={{ fontSize: '0.8rem', color: '#718096', marginTop: '0.25rem' }}>
                {card.source_lang} → {card.target_lang}
                {card.category_name && ` · ${card.category_name}`}
              </div>
              {card.notes && (
                <div style={{
                  marginTop: '0.5rem', fontSize: '0.85rem',
                  background: '#fffbeb', padding: '0.4rem 0.75rem',
                  borderRadius: '6px', color: '#744210'
                }}>
                  {card.notes}
                </div>
              )}
              {card.example_source && (
                <div style={{
                  marginTop: '0.5rem', fontSize: '0.85rem',
                  background: '#f7fafc', padding: '0.4rem 0.75rem',
                  borderRadius: '6px', borderLeft: '3px solid #4c51bf'
                }}>
                  <div>{card.example_source}</div>
                  <div style={{ color: '#4c51bf' }}>{card.example_target}</div>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginLeft: '1rem' }}>
              <span className={`level-badge level-${card.level}`}>
                Stufe {card.level} — {levelNames[card.level]}
              </span>
              <button className="btn-secondary" onClick={() => handleEdit(card)}
                style={{ padding: '0.4rem 0.8rem', fontSize: '0.85rem' }}>
                Bearbeiten
              </button>
              <button className="btn-danger" onClick={() => handleDelete(card.id)}
                style={{ padding: '0.4rem 0.8rem' }}>
                Löschen
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Cards;